import { cpfMask, creditCardMask, phoneMask } from '~/utils/masks';
import { IListColCampaing } from '../../model';
import { icons } from '~/assets';
import {
  ICustomer,
  IResponseCustomerData,
  medalsIcons,
} from './interfaceModels';

/**
 * Header da tabela para incluir clientes manualmente.
 */
export const customerHeaderManual = [
  {
    id: 1,
    value: 'Nome Completo',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 15,
  },
  {
    id: 3,
    value: 'Telefone',
    maxChar: 15,
  },
  {
    id: 4,
    value: 'Número do Cartão',
    maxChar: 20,
  },
  {
    id: 5,
    value: 'E-mail',
    maxChar: 18,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Bairro',
    maxChar: 10,
    textAlign: 'center',
  },
  {
    id: 7,
    value: '',
    maxChar: 5,
    textAlign: 'center',
  },
];

/**
 * Header da tabela de clientes atingidos pela campanha.
 */
export const customerHeader = [
  {
    id: 1,
    value: '',
    maxChar: 5,
    textAlign: 'center',
  },
  {
    id: 2,
    value: 'Nome',
    maxChar: 20,
  },
  {
    id: 3,
    value: 'CPF',
    maxChar: 15,
  },
  {
    id: 4,
    value: 'Telefone',
    maxChar: 15,
  },
  {
    id: 5,
    value: 'Número do Cartão',
    maxChar: 20,
  },
  {
    id: 6,
    value: 'E-mail',
    maxChar: 18,
    textAlign: 'center',
  },
  {
    id: 7,
    value: 'Bairro',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Inserido',
    maxChar: 13,
    textAlign: 'center',
  },
];

/**
 * Monta a lista de cliente inseridos manualmente e a serem inseridos.
 */
export const buildManualInsertList = (
  data: IResponseCustomerData[],
  setListInsertManual: React.Dispatch<React.SetStateAction<IListColCampaing[]>>,
  goToInsert: (item: IResponseCustomerData) => void,
) => {
  const newList = [];
  data?.forEach((i) => {
    const item: IListColCampaing[] = [
      { value: i.nomeCompleto, maxChar: 20, textAlign: 'center' },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 15,
      },
      {
        value: phoneMask(i.celular).masked,
        maxChar: 15,
      },
      {
        value: creditCardMask(i.numeroCartao).masked,
        maxChar: 20,
      },
      {
        value: i.email,
        maxChar: 18,
        textAlign: 'center',
      },
      {
        value: i.bairro,
        maxChar: 10,
        textAlign: 'center',
      },
      {
        type: 'icon',
        icon: i.insertedManually ? icons.checkGreen : icons.addGreen,
        item: i,
        data,
        action: i.insertedManually ? undefined : goToInsert,
        maxChar: 5,
        textAlign: 'center',
      },
    ];

    newList.push(item);
  });
  setListInsertManual(newList);
};

/**
 * Monta a lista de clientes atingidos pela campanha.
 */
export const buildCustomerList = (
  data: ICustomer,
  setList: React.Dispatch<React.SetStateAction<IListColCampaing[]>>,
) => {
  const newList = [];
  let i = 0;
  data.pagina?.forEach((data) => {
    const item: IListColCampaing[] = [
      {
        type: 'id',
        value: i++,
        maxChar: 1,
      },
      {
        maxChar: 5,
        type: 'icon',
        icon: data.nivel && medalsIcons[data.nivel],
        textAlign: 'center',
        marginLeft: 5,
      },
      { value: data.nomeCompleto, maxChar: 20 },
      {
        value: cpfMask(data.cpf).masked,
        maxChar: 15,
      },
      {
        value: phoneMask(data.celular).masked,
        maxChar: 15,
      },
      {
        value: creditCardMask(data.numeroCartao).masked,
        maxChar: 20,
      },
      {
        value: data.email,
        maxChar: 18,
        textAlign: 'center',
      },
      {
        value: data.bairro,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: data.inseridoManualmente ? 'Manual' : 'Automático',
        maxChar: 13,
        textAlign: 'center',
      },
    ];

    newList.push(item);
  });
  setList(newList);
};
